// const TELEGRAM_BOT_TOKEN = "7905854332:AAG10-AwNe5YMueLMi51bPHddbW0B3qwuKM"
const TELEGRAM_BOT_TOKEN = "8159868982:AAGruHSAe8hUTSV-t7SEwJQhwF3LgYdxOQU"
const CHAT_ID = "@rservicekyiv"

export const logMessage = async (text) => {
  try {
    const message = text
    const response = await fetch(
      `https://api.telegram.org/bot${TELEGRAM_BOT_TOKEN}/sendMessage`,
      {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ chat_id: CHAT_ID, text: message }),
      }
    )
    const data = await response.json()
    if (data.ok) {
      console.log("success")
    } else {
      console.log("error")
    }
  } catch {
    console.log("catch")
  } finally {
    console.log("finally")
  }
}
